<template>
  <div id="layout">
    <comp-header-pc></comp-header-pc>
    <div id="appMain">
      <app-main />
    </div>
    <comp-footer-pc></comp-footer-pc>
    <comp-login-modal></comp-login-modal>
  </div>
</template>

<script>
import ResizeMixin from "./mixin/ResizeHandler";
import CompHeaderPc from "@/components/CompHeaderPc.vue";
import CompFooterPc from "@/components/CompFooterPc.vue";
import CompLoginModal from "@/components/CompLoginModal.vue";
import { AppMain } from "./components";
import { getVideoConfig } from "@/api/live/liveRecordDetail";
export default {
  name: "Layout",
  components: {
    CompHeaderPc,
    AppMain,
    CompFooterPc,
    CompLoginModal,
  },
  mixins: [ResizeMixin],
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
  },
  created() {
    let that = this;
    window.onload = function () {
      let favicon = document.getElementById("favicon");
      favicon.href = "/favicon.ico";
      that.onGetVideoConfig();

    }
    window.onbeforeunload = function (e) {
      let favicon = document.getElementById("favicon");
      favicon.href = "/favicon.ico";
    };
  },
  mounted() {
    this.onGetVideoConfig();
  },
  methods: {
    // 获取视频配置信息
    onGetVideoConfig() {
      return new Promise((resolve, reject) => {
        let favicon = document.getElementById("favicon");
        getVideoConfig().then((res) => {
          res.data.colors = res.data.colors ? res.data.colors : "#a60002";
          // 处理favicon
          if (favicon) {
            if (this.$route.query?.schoolId || localStorage.getItem("token") || localStorage.getItem('requestSchoolId')) {
              favicon.href = res.data.schoolBranch || "/faviconDefault.ico";
            } else {
              favicon.href = "/faviconDefault.ico";
            }
          } else {
            favicon.href = "/favicon.ico";
          }
          if (this.$route.query?.schoolId || localStorage.getItem("token")) {
            document.title = res.data.schoolName || "红海云课堂";
          } else {
            document.title = "红海云课堂";
          }
          this.$store.dispatch("public/setSchoolInfo", res.data);
          resolve(res.data);
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
#layout {
  width: 100%;
  background-color: #f4f4f4;

  #appMain {
    width: 100%;
    margin-top: 76px;
    background-color: #f4f4f4;
  }
}
</style>
